
import React, {useState, useReducer} from 'react';
import CardComponent from '../CardComponent';
import FileComponent from '../FileComponent';
export default function SteelHaxComponent(props) {
  const [status, setStatus] = useReducer((status, msg)=>{return status.concat([msg]); },[]);
  const [movableLoaded, setMovableLoaded] = useState(false);
  const [keyy, setKeyy] = useState(null);
  const [buildWorker, setBuildWorker] = useState(null);
  const [tid, setTid] = useState("00040000000d7d00")
  let handleBWMessage=(msg)=> {
    switch(msg.data.cmd) {
        case "addStatus":
          onStatus(msg.data.val.msg, msg.data.val.color);
          break;
        case "download":
            props.onDownload(msg.data.val.fname,msg.data.val.content);
            break;
        default:
          console.log("unknown message from worker "+msg.data.val.msg);
          break;
    }
  }
  let onStatus=(statusMessage, type)=>
  {
    setStatus({msg: statusMessage, type:type});
  }
  let buildSave=()=>{
    if (buildWorker != null && typeof(buildWorker) != "undefined") {
        buildWorker.terminate();
    }

    let newBuildWorker = new Worker("../Workers/3DSSaveBuilder.js");
    newBuildWorker.addEventListener('message', handleBWMessage);
    newBuildWorker.postMessage({cmd:"encrypt",val:{referrer: document.referrer, keyy: keyy, tid: tid, url:"/data/steelhax_save.bin"}});
    setBuildWorker(newBuildWorker);
}
  return (
        <CardComponent status={status} title="Untested SteelHax Save Tool">
        <FileComponent hint='Do not choose "movable_part1.sed"' id="movable" defaultFilename="movable.sed" filter=".sed" onStatus={setStatus} 
            onPreValidate={(data)=>{
              setMovableLoaded(false);
              setKeyy(null);

            return {ok:(data.size===288 || data.size === 320 || data.size===16), msg: "Incorrect filesize for chosen movable.sed"}
          }} 
          onPostValidate={data=>{
            return true;
          }}
          onLoaded={data=>{
            setMovableLoaded(true);
            if (data.byteLength > 16) {
              setKeyy(new Uint8Array(data.slice(0x110,0x120)));
            }else {
              setKeyy(new Uint8Array(data.slice(0,16)));
            }
          }} />
          <select value={tid} onChange={(e)=>{console.log(e.target.value);setTid(e.target.value); return true;}} >
            <option id="usa" value="00040000000d7d00" defaultChecked={true}>USA</option>
            <option id="eur" value="00040000000d7e00">EUR</option>
            <option id="jpn" value="00040000000d7c00">JPN</option>
          </select>
          <div className="form-group">
          <input type="button" id="build" value="Build and Download" disabled={!movableLoaded} onClick={(e)=>{
                  buildSave();
                }} className={(movableLoaded)?"btn btn-success":"btn btn-secondary"} />
            </div>
        </CardComponent>
  );
}


